<template>
    <vue-scroll>
        <div class="mb-10">
            <el-input
                placeholder="Search Users..."
                style="width: 250px"
                v-model="filter.search"
            />
        </div>
        <p>Please select users by clicking the checkboxes on the left.</p>
        Selected: {{ selectedUsers.length }}
        <el-table
            :data="users.data"
            @select="onSelect"
            @select-all="onSelectAll"
            ref="table"
            row-key="id"
            v-loading="users.meta.loading"
        >
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column label="Name" prop="name"></el-table-column>
            <el-table-column label="Email" prop="email"></el-table-column>
            <el-table-column
                label="Phone Number"
                prop="phone_number"
            ></el-table-column>
            <el-table-column label="Active" prop="is_active" width="100px">
                <template slot-scope="scope">
                    <i
                        class="mdi mdi-check success-text"
                        v-if="scope.row.is_active"
                    ></i>
                    <i class="mdi mdi-close danger-text" v-else></i>
                </template>
            </el-table-column>
        </el-table>
        <div class="mt-10">
            <app-pagination
                :disabled="users.meta.loading"
                :pagination="users.meta.pagination"
                @current-change="onPageChange"
            />
        </div>
    </vue-scroll>
</template>

<script>
export default {
    props: {
        readonly: {
            type: Boolean,
            default: false
        },
        corporation: {
            type: Object,
            default: null
        },
        filterable: {
            type: Boolean,
            default: true
        },
        exceptUsers: {
            type: Array
        },
        role: {
            type: Array
        }
    },
    data() {
        return {
            users: {
                data: [],
                meta: {
                    pagination: null,
                    loading: false
                }
            },
            filter: {
                search: ""
            },
            currentQuery: {
                filter: {
                    search: ""
                },
                page: 1
            },
            selectedUsers: []
        };
    },
    computed: {
        exceptIds() {
            if (!this.exceptUsers) {
                return [];
            }
            return _.values(
                this.exceptUsers.map((user) => user.id).filter((id) => !!id)
            );
        }
    },
    mounted() {
        this.getUsers();
    },
    watch: {
        "filter.search": _.debounce(function () {
            this.currentQuery.filter.search = this.filter.search;
            this.currentQuery.page = 1;
            this.getUsers();
        }, 600)
    },
    methods: {
        getUsers() {
            this.users.meta.loading = true;
            axios
                .get(`/web-api/user`, {
                    params: {
                        ...this.currentQuery,
                        except_ids: this.exceptIds,
                        role: this.role,
                        corporation_id: this.corporation
                            ? this.corporation.id
                            : null,
                        finder: 1
                    }
                })
                .then((response) => {
                    this.users.data = _.sortBy(response.data.data, "name");
                    this.users.meta.pagination = response.data.meta.pagination;
                    Vue.nextTick(() => {
                        this.toggleTableSelections();
                    });
                })
                .finally(() => (this.users.meta.loading = false));
        },
        toggleTableSelections() {
            this.selectedUsers.forEach((user) => {
                let existing = _.find(this.users.data, { id: user.id });
                if (existing) {
                    this.$refs.table.toggleRowSelection(existing, true);
                }
            });
        },
        onPageChange(page) {
            this.currentQuery.page = page;
            this.getUsers();
        },
        onSelect(selection, user) {
            let selected = !!_.find(selection, { id: user.id });
            if (selected) {
                if (!_.find(this.selectedUsers, { id: user.id })) {
                    this.selectedUsers.push(user);
                }
            } else {
                this.selectedUsers = _.reject(this.selectedUsers, {
                    id: user.id
                });
            }
            this.sendSelectionChangeEvent();
        },
        onSelectAll(selection) {
            this.users.data.forEach((user) => {
                let selected = !!_.find(selection, { id: user.id });
                if (selected) {
                    if (!_.find(this.selectedUsers, { id: user.id })) {
                        this.selectedUsers.push(user);
                    }
                } else {
                    this.selectedUsers = _.reject(this.selectedUsers, {
                        id: user.id
                    });
                }
            });
            this.sendSelectionChangeEvent();
        },
        sendSelectionChangeEvent() {
            this.$emit("selection-change", this.selectedUsers);
        }
    }
};
</script>

<style scoped></style>
